export const index = {
  name: 'organisation-journeys',
  path: '/organisation/journeys',
  components: {
    default: () => import(/* webpackChunkName: "organisation-journeys" */ 'pages/journeys/backoffice-journeys/index.vue')
  }
}

export default { index }
